/**
 * internal dependencies
 */
import { PIN_POOL_FORM, VEHICLE_POOL_FORM, COMMON_FORM_ELEMENTS } from "../utils/pin-pool-types";
import { usePinPool } from "../utils/use-pin-pool";
import { removePinPool } from "../remove/remove-pinpool";
import { IPinPool } from "../../../../../models/cardgroup.interface";

/**
 * Function to control the warning modal in the Pin Pool form page.
 * 
 * @param {number} askFor - indicates which form is being used (1 for Pin Pool, 2 for Vehicle Pool)
 * @param {IPinPool} data - the Pin Pool data
 * 
 * @returns void
 */
const WarningModalControl = (askFor: number, data: IPinPool,) => {
  const { ceOptional, ceWarningModal } = COMMON_FORM_ELEMENTS;
  const warningPinPoolModalclose = document.querySelector('#aafp_pin-pool-dismissed') as HTMLElement;
  const deletePinPoolContainer = document.querySelector('#aafp_pin-pool-deleted') as HTMLElement;
  const modalHeader = document.querySelector('.modal_warning-header') as HTMLElement;
  const poolType = askFor === 1 ? 'Driver' : 'Vehicle';
  const modalHeaderMSG = `Existing ${poolType} Pins for Card Group:`;
  const modalTextMSG = data.body.cardGroup.cardGroupName;

  const modalTitle = document.createElement('h5');
  modalTitle.id = 'pinWarningModalLabel';
  modalTitle.classList.add('modal_warning-title');
  modalTitle.textContent = modalHeaderMSG;

  const modalText = document.createElement('span');
  modalText.classList.add('modal_warning-subtitle');
  modalText.textContent = modalTextMSG;
  modalHeader.appendChild(modalTitle);
  modalHeader.appendChild(modalText);

  const modalBodyText = document.querySelector('.modal_warning-text') as HTMLElement;
  modalBodyText.textContent = `This card group has existing ${poolType.toLowerCase()} pins in the pool.  If you proceed, none of the pins will be required for fueling.  Are you sure you want to proceed?`;

  const availablePinPool = askFor === 1 ? PIN_POOL_FORM.ppActive : VEHICLE_POOL_FORM.vpActive;

  ceWarningModal.style.display = 'block';
  
  warningPinPoolModalclose.onclick = function() {
    ceWarningModal.style.display = 'none';
    availablePinPool.checked = true;
    usePinPool(availablePinPool, data, askFor);
  }

  deletePinPoolContainer.onclick = function() {
    ceWarningModal.style.display = 'none';
    ceOptional.forEach(field => {
      field.classList.add('aafp_pin-disabled');
    });
    removePinPool(askFor);
  };
}

export default WarningModalControl;